// FAQ data for homepage and general legal questions

export const homepageFaqs = [
  {
    id: 1,
    question: "What types of businesses does Legal Emphasis represent?",
    answer: "We represent businesses of all sizes, from startups and small businesses to Fortune 500 corporations. Our clients span diverse industries including technology, manufacturing, healthcare, financial services, and non-profit organizations."
  },
  {
    id: 2,
    question: "How do I schedule a consultation?",
    answer: "You can schedule a consultation by clicking the 'Get Legal Help' button on our website, calling our office, or sending an email to info@legalemphasis.com. We typically respond within one business day to arrange a meeting."
  },
  {
    id: 3,
    question: "What should I bring to an initial consultation?",
    answer: "Please bring any relevant documents such as contracts, correspondence, corporate formation documents, or other materials related to your legal matter. The more information you can provide, the better we can assess your situation."
  },
  {
    id: 4,
    question: "Do you offer flat-fee arrangements?",
    answer: "Yes, we offer flat-fee arrangements for many services including business formation, trademark registration, and contract drafting. We discuss fee structures during our initial consultation to find the best arrangement for your needs."
  },
  {
    id: 5,
    question: "Can you represent clients outside of California?",
    answer: "Yes, many of our attorneys are licensed in multiple states, and we regularly handle matters involving federal law, multi-state transactions, and international business. We can discuss the specifics of your situation during consultation."
  },
  {
    id: 6,
    question: "What makes Legal Emphasis different from other law firms?",
    answer: "We combine deep legal expertise with a practical business mindset. Our attorneys understand that legal matters are part of broader business objectives, and we tailor our advice to help you achieve your goals efficiently and effectively."
  }
];
